export default function I18n(value) {
    const langs = window.langs;

    return langs?.[value];
}